import { OperationGrievance } from '../../../services/types/Operation';
import { Action, ApiState } from '../../../types';
import { callService, serviceReducer } from '../../../shared/hooks/serviceReducer';
import { Paged } from '../../../services/types/Misc';

import { GrievanceFilter } from '../../../services/types/Grievance';

export type OperMissionAction =
  | Action<Paged<OperationGrievance>, GrievanceFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<Paged<OperationGrievance>, GrievanceFilter>,
  action: OperMissionAction
): ApiState<Paged<OperationGrievance>, GrievanceFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { ...state.filter, pageNumber: action.value });
    case 'ORDER':
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        sortField: action.column,
        sortDescending: action.descending,
      });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
